module.exports = __webpack_public_path__ + "static/media/Screenshot8.6f7a0d19.png";